import { Component } from "@angular/core";
import { OnRouteService } from "@app/shared/services/onroute.services";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent {
  constructor(private onRouteService: OnRouteService) {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts